// import { AuthConfig } from 'angular-oauth2-oidc';
// import {environment} from '../environments/environment';
import {InjectionToken} from '@angular/core';
export const ENVIRONMENT_AUTH_CONFIG  = new InjectionToken<string>('auth config');
// export const authConfig: AuthConfig = {
//   // loginUrl: environment.authLoginUrl,
//   // logoutUrl: environment.authLogoutUrl,
//   redirectUri: window.location.href,
//   postLogoutRedirectUri: window.location.origin,
//   clientId: 'ItemSharingWebAdmin',
//   requireHttps: false,
//   oidc: false,
//   clearHashAfterLogin: true,
//   silentRefreshRedirectUri: window.location.origin + '/assets/silent-refresh.html',
// };
